import React, { useState } from 'react';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import { formatCurrency, generateId } from '../utility/functions';
import Table from '../table/Table';
import useMetronome from '../utility/useMetronome';

const AppActivity = ({ ...props }) => {

    // return (<div>Temporarily Unavailable</div>);

    const [data, setData] = useState([]);
    const [fetchData, setFetchData] = useState(5);

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.appActivity)
                .then(res => {
                    const data = [
                        {
                            label: 'Purchase Income',
                            today: res.dailyWashesIncome,
                            month: res.mtdWashesIncome,
                            currency: true
                        },
                        {
                            label: 'Total Purchases',
                            today: res.dailyWashesCount,
                            month: res.mtdWashesCount,
                        },
                        {
                            label: 'AirPAY Income',
                            today: res.dailyAirPayIncome,
                            month: res.mtdAirPayIncome,
                            currency: true
                        },
                        {
                            label: 'AirPAY Transactions',
                            today: res.dailyAirPayTransactions,
                            month: res.mtdAirPayTransactions,
                        },
                        {
                            label: 'Claimed Used Count',
                            today: res.dailyClaimedUsedCount,
                            month: res.mtdClaimedUsedCount,
                        },
                        {
                            label: 'Code Deal Income',
                            today: res.dailyCodeDealIncome,
                            month: res.mtdCodeDealIncome,
                            currency: true
                        },
                        {
                            label: 'Code Used Count',
                            today: res.dailyCodeUsedCount,
                            month: res.mtdCodeUsedCount,
                        },
                        {
                            label: 'Deals Used Count',
                            today: res.dailyDealsUsedCount,
                            month: res.mtdDealsUsedCount,
                        },
                        {
                            label: 'Recurring Wash Club Income',
                            today: res.dailyRecurringWashClubIncome,
                            month: res.mtdRecurringWashClubIncome,
                            currency: true
                        },
                        {
                            label: 'Redeemed Deal Income',
                            today: res.dailyRedeemedDealIncome,
                            month: res.mtdRedeemedDealIncome,
                            currency: true
                        },
                        {
                            label: 'Wash Club Count',
                            today: res.dailyWashClubCount,
                            month: res.mtdWashClubCount,
                        },
                        {
                            label: 'Wash Club Income',
                            today: res.dailyWashClubIncome,
                            month: res.mtdWashClubIncome,
                            currency: true
                        },
                        {
                            label: 'Wash Club Signups',
                            today: res.dailyWashClubSignups,
                            month: res.mtdWashClubSignups,
                        }
                    ].filter(e => e.today > 0 || e.month > 0)

                    setData(data)
                })
                .catch(ex => console.error(ex))
        }
    }, 60000)

    return (
        <Table
            config={{
                disableHeaderSearch: true,
                disableMobileView: true,
                disableTableControls: true,
                data: data,
                headers: [
                    {
                        label: 'Mobile App Totals',
                        propKey: 'label',
                    }, {
                        label: 'Today',
                        propKey: 'today',
                    }, {
                        label: 'Month',
                        propKey: 'month',
                    }
                ],
                renderFormat: (e) => (
                    <tr key={generateId()}>
                        <td>{e.label}</td>
                        <td>{e.currency ? formatCurrency(e.today) : e.today}</td>
                        <td>{e.currency ? formatCurrency(e.month) : e.month}</td>
                    </tr>
                )
            }}
        />
    );
}

export default AppActivity;